import { render } from "./invalid.vue?vue&type=template&id=0704181b&scoped=true"
import script from "./invalid.vue?vue&type=script&lang=js"
export * from "./invalid.vue?vue&type=script&lang=js"

import "./invalid.vue?vue&type=style&index=0&id=0704181b&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0704181b"]])

export default __exports__